import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation} from '@angular/core';
import {FuseSplashScreenService} from "@fuse/services/splash-screen.service";
import {GameSettingsService} from "@app/main/content/game-settings/game-settings.service";
import {AdminApi} from "@lbsdk/*";
import {environment} from "@env/environment";
import {FormBuilder, FormGroup} from "@angular/forms";

@Component({
  selector: 'invite-image-color-gradient',
  templateUrl: './invite-image-color-gradient.component.html',
  styleUrls: ['./invite-image-color-gradient.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class InviteImageColorGradientComponent implements OnInit, OnChanges {
  @Input('data') data: any;
  @Input('logo') logo: any;
  @Input('menuArt') menuArt: any;
  selectedColor: any;
  onErrorSrc = '/assets/images/image-not-found-150x150.png';
  s3BucketUrl: any;
  colorGradientForm: FormGroup;

  constructor(private _fuseSplashScreenService: FuseSplashScreenService,
              private _gameSettingsService: GameSettingsService,
              private _adminApi: AdminApi,
              private _formBuilder: FormBuilder) {
  }

  /**
   * life cycle method
   */

  ngOnInit() {
    this.s3BucketUrl = environment.s3BucketUrl;
    this.colorGradientForm = this.createColorGradientForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.s3BucketUrl = environment.s3BucketUrl;
    if (changes.menuArt) {
      this.menuArt = changes.menuArt.currentValue;
      if (this.menuArt && this.menuArt.replace(this.s3BucketUrl, '')) {
        this.menuArt = this.menuArt.replace(this.s3BucketUrl, '');
      }
    }
    if (changes.data) {
      this.data = changes.data.currentValue;
      this.colorGradientForm = this.createColorGradientForm();
    }
    if (changes.logo) {
      this.logo = changes.logo.currentValue;
      if (this.logo && this.logo.replace(this.s3BucketUrl, '')) {
        this.logo = this.logo.replace(this.s3BucketUrl, '');
      }
    }
  }

  /**
   * public methods
   */

  createColorGradientForm() {
    return this._formBuilder.group({
      top1stColor: [this.data.invite.topToolbar.color.first],
      top2ndColor: [this.data.invite.topToolbar.color.second],
      left1stColor: [this.data.invite.leftCurtain.color.first],
      left2ndColor: [this.data.invite.leftCurtain.color.second],
      right1stColor: [this.data.invite.rightCurtain.color.first],
      right2ndColor: [this.data.invite.rightCurtain.color.second],
      footer1stColor: [this.data.invite.footer.color.first],
      footer2ndColor: [this.data.invite.footer.color.second],
    });
  }

  isExpand($event) {
    this.data.invite.powerBar.isExpand = $event.checked;
  }

  powerBarUpload($event) {
    if ($event.target.files.length) {
      this._fuseSplashScreenService.show();
      this._gameSettingsService.upload($event, this._gameSettingsService.powerBarUploadPath,
        this._adminApi.getCurrentToken().id).then((response: any) => {
        this.data.invite.powerBar.image = response.result.files['file'][0]['providerResponse'].name;
        this._fuseSplashScreenService.hide();
      }, error => {
        this._fuseSplashScreenService.hide();
      });
    }
  }

  powerBarAudioUpload($event) {
    if ($event.target.files.length) {
      this._fuseSplashScreenService.show();
      this._gameSettingsService.upload($event, this._gameSettingsService.powerBarAudioUploadPath,
        this._adminApi.getCurrentToken().id).then((response: any) => {
        this.data.invite.powerBarAudio.image = response.result.files['file'][0]['providerResponse'].name;
        this._fuseSplashScreenService.hide();
      }, error => {
        this._fuseSplashScreenService.hide();
      });
    }
  }

  updateInviteColorGradient(type, value) {
    if (type === 'top1stColor') {
      this.data.invite.topToolbar.color.first = value;
    } else if (type === 'top2ndColor') {
      this.data.invite.topToolbar.color.second = value;
    } else if (type === 'left1stColor') {
      this.data.invite.leftCurtain.color.first = value;
    } else if (type === 'left2ndColor') {
      this.data.invite.leftCurtain.color.second = value;
    } else if (type === 'right1stColor') {
      this.data.invite.rightCurtain.color.first = value;
    } else if (type === 'right2ndColor') {
      this.data.invite.rightCurtain.color.second = value;
    } else if (type === 'footer1stColor') {
      this.data.invite.footer.color.first = value;
    } else if (type === 'footer2ndColor') {
      this.data.invite.footer.color.second = value;
    }
  }

}
